export const REPORTS_TABLES_COLUMNS = {
    'nodes-report': [
        {
            id: 'lot_code',
            key: 'lot_code',
            title: 'Code',
            minWidth: 0,
            maxWidth: 0,
            additionalClasses: 'is-sortable is-unselectable',
        },
        {
            id: 'lot_title',
            key: 'lot_title',
            title: 'Titre',
            minWidth: 0,
            maxWidth: 0,
            additionalClasses: 'is-sortable is-unselectable',
        },
        {
            id: 'lot_total_exc_vat',
            key: 'lot_total_exc_vat',
            title: 'Montant Total H.T',
            minWidth: 0,
            maxWidth: 0,
            additionalClasses: 'is-sortable is-unselectable has-text-right',
        },
    ],
    'nodes-by-location-report': [
        {
            id: 'lot_code',
            key: 'lot_code',
            title: 'Code',
            minWidth: 0,
            maxWidth: 0,
            additionalClasses: 'is-sortable is-unselectable',
        },
        {
            id: 'lot_title',
            key: 'lot_title',
            title: 'Titre',
            minWidth: 0,
            maxWidth: 0,
            additionalClasses: 'is-sortable is-unselectable',
        },
        {
            id: 'lot_total_exc_vat',
            key: 'lot_total_exc_vat',
            title: 'Montant Total H.T',
            minWidth: 0,
            maxWidth: 0,
            additionalClasses: 'is-sortable is-unselectable has-text-right',
        },
    ],
    'classification-report': [
        {
            id: 'classification_code',
            key: 'classification_code',
            title: 'Code',
            minWidth: 0,
            maxWidth: 0,
            additionalClasses: 'is-sortable is-unselectable',
        },
        {
            id: 'classification_title',
            key: 'classification_title',
            title: 'Titre',
            minWidth: 0,
            maxWidth: 0,
            additionalClasses: 'is-sortable is-unselectable',
        },
        {
            id: 'classification_unit',
            key: 'classification_unit',
            title: 'Unité Réf.',
            minWidth: 0,
            maxWidth: 0,
            additionalClasses: 'is-sortable is-unselectable',
        },
        {
            id: 'classification_total_exc_vat',
            key: 'classification_total_exc_vat',
            title: 'Montant Total H.T',
            minWidth: 0,
            maxWidth: 0,
            additionalClasses: 'is-sortable is-unselectable has-text-right',
        },
    ],
    // 'nodes-by-category-and-location-report': [
    //     {
    //         id: 'lot_code',
    //         key: 'lot_code',
    //         title: 'Code',
    //         minWidth: 0,
    //         maxWidth: 0,
    //         additionalClasses: 'is-sortable is-unselectable',
    //     },
    //     {
    //         id: 'lot_title',
    //         key: 'lot_title',
    //         title: 'Titre',
    //         minWidth: 0,
    //         maxWidth: 0,
    //         additionalClasses: 'is-sortable is-unselectable',
    //     },
    //     {
    //         id: 'lot_total_exc_vat',
    //         key: 'lot_total_exc_vat',
    //         title: 'Montant Total H.T',
    //         minWidth: 0,
    //         maxWidth: 0,
    //         additionalClasses: 'is-sortable is-unselectable has-text-right',
    //     },
    // ],
};
